{
  "version": 1,
  "asset_id": "5d3d2f9e-275f-45a5-8749-2c103dcc53a9",
  "project_id": "e3708065-dee2-4f65-a2de-1d1b02caf785",
  "url": "/__l5e/assets-v1/5d3d2f9e-275f-45a5-8749-2c103dcc53a9/the-diamond-sutra-cover.png",
  "r2_key": "a/v1/e3708065-dee2-4f65-a2de-1d1b02caf785/5d3d2f9e-275f-45a5-8749-2c103dcc53a9/the-diamond-sutra-cover.png",
  "original_filename": "the-diamond-sutra-cover.png",
  "size": 471012,
  "content_type": "image/webp",
  "created_at": "2026-08-07T07:03:26Z"
}
